// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"978c861b","77":"9bae3da7","168":"73036587","274":"34224fd0","901":"77349920"}[chunkId] + ".chunk.css";
};